// Utilities
import { getLanguageFromUrl } from 'utils/browser-url.utils';

const CUSTOM_BANK_ID = {
  bankId: 'CF_ES',
};

const GIL_API_CHANNEL = {
  channel: 'gil',
  customHeaders: { ...CUSTOM_BANK_ID },
  language: getLanguageFromUrl(),
};

export { CUSTOM_BANK_ID, GIL_API_CHANNEL };
